import React from 'react';

export const filter = (color = 'rgba(125,125,125, 0.5)', filled = true, width = 16, height = 16) => (
  <svg width={width} height={height} viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4,7h5c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h11c0.6,0,1-0.4,1-1s-0.4-1-1-1H17
      c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3S9.6,3.3,9.1,5C9.1,5,9,5,9,5H4C3.4,5,3,5.4,3,6S3.4,7,4,7z'
      fill={filled ? color : 'none'}
    />
    <path
      d='M28,15h-4c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3c0,0-0.1,0-0.1,0H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h12
	  c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h4c0.6,0,1-0.4,1-1S28.6,15,28,15z'
      fill={filled ? color : 'none'}
    />
    <path
      d='M28,25H17c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3c0,0-0.1,0-0.1,0H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h5
      c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h11c0.6,0,1-0.4,1-1S28.6,25,28,25z'
      fill={filled ? color : 'none'}
    />
  </svg>
);
